import { AlertColor } from '@mui/material';
import { create } from 'zustand';
import { normalizeSnackbarMessage } from './snackbar.utils';

export type SnackbarMessageType = AlertColor;

export type SnackbarState = {
  message: string | undefined;
  title?: string;
  type: SnackbarMessageType;
  loading?: boolean;
};

interface SnackbarStoreState {
  open: boolean;
  state: SnackbarState;
  handleMessage: (props: SnackbarState) => void;
  showSuccess: (message: string) => void;
  close: () => void;
}

export const useSnackbarStore = create<SnackbarStoreState>((set) => ({
  open: false,
  state: {
    message: '',
    type: 'info',
  },

  handleMessage: (props) => {
    set({
      open: true,
      state: {
        ...props,
        message: normalizeSnackbarMessage(props.message),
        title: props.title ? normalizeSnackbarMessage(props.title) : undefined,
      },
    });
  },

  showSuccess: (message) => {
    set({ open: true, state: { type: 'success', message: normalizeSnackbarMessage(message) } });
  },

  close: () => {
    set({ open: false });
  },
}));

const snackbarStore = {
  get open() {
    return useSnackbarStore.getState().open;
  },
  get state() {
    return useSnackbarStore.getState().state;
  },
  handleMessage: (props: SnackbarState) => useSnackbarStore.getState().handleMessage(props),
  showSuccess: (message: string) => useSnackbarStore.getState().showSuccess(message),
  close: () => useSnackbarStore.getState().close(),
};

export default snackbarStore;
